// extracted by mini-css-extract-plugin
module.exports = {"root":"badge_root___Z7Nt","default":"badge_default__zBvbO","secondary":"badge_secondary__3zUL2","destructive":"badge_destructive__qh2ji","outline":"badge_outline__UARDS"};